import React from 'react';
import styles from './CirclePhotoAndQuote.module.scss';

const CirclePhotoAndQuote = ({ photo, text, author }) => {
  return (
    <div className={ styles.CirclePhotoAndQuote }>
      <figure className={ styles.photo }>
        <img src={ photo } />
      </figure>
      <div>
        <p className={ styles.quote }>&ldquo;{ text }&rdquo;</p>
        <p className={ styles.author }>
          <span className={ styles.name }>{ author.name }</span>,&nbsp;
          <span className={ styles.position }>{ author.position }</span>
        </p>
      </div>
    </div>
  );
};
 
export default CirclePhotoAndQuote;